// [2025-02-26], Tom Walsh - TODO: This page is not used anymore, but we should keep it for now just incase. I belive it was replaced by the new markets overview page.

import React, { FC, useEffect } from 'react';
import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import useTitleBarInput from '../../../../hooks/useTitleBarInput';
import MarketLookbackTable from './subComponents/MarketLookbackTable.component';
import { useDispatch } from 'react-redux';
import {
  addAdditionalTitleBarComponents,
  removeTitleBarComponent,
} from '../../../../redux/pages/actions';
import {
  APPEND_NEW_INPUT_TO_TITLEBAR,
  APPEND_NEW_SELECT_TO_TITLEBAR,
  REMOVE_INPUT_FROM_TITLEBAR,
  REMOVE_SELECT_FROM_TITLEBAR,
} from '../../../../types/redux/pages/pageTypes';
import useTitleBarSelect from '../../../../hooks/useTitleBarSelect';
import { Input, Select } from '../../../../types/redux/pages/PagesStore';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useMarketLookbackPageQuery } from '../../../../api/rs-hg/risk/hooks/queries';
import type { MarketLookbackPayload } from '../../../../api/rs-hg/risk/marketLookback.types';

const MarketLookbackPage: FC<
  GeneralOverviewPageRenderedComponentProps
> = ({ positionDate }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const selectsToAdd: Select[] = [
      {
        displayOnOverviewPage: true,
        titleBarKey: 'selectMarketLookbackType',
        titleBarTitle: 'Type: ',
        values: [
          {
            label: 'Volatility',
            value: 'vol',
          },
          {
            label: 'VaR',
            value: 'var',
          },
        ],
        aValueIsAlwaysSelected: true,
        currentValue: 'vol',
      },
    ];

    dispatch(
      addAdditionalTitleBarComponents(
        selectsToAdd,
        APPEND_NEW_SELECT_TO_TITLEBAR,
      ),
    );

    const inputsToAdd: Input[] = [
      {
        displayOnOverviewPage: true,
        titleBarKey: 'marketLookbackDays',
        titleBarTitle: 'Lookback Days: ',
        currentValue: '1',
        defaultValue: '1',
        allowedValues: [...Array(1000).keys()].map((i) => String(i + 1)),
      },
    ];

    dispatch(
      addAdditionalTitleBarComponents(
        inputsToAdd,
        APPEND_NEW_INPUT_TO_TITLEBAR,
      ),
    );

    return () => {
      dispatch(
        removeTitleBarComponent(
          'selectMarketLookbackType',
          REMOVE_SELECT_FROM_TITLEBAR,
        ),
      );
      dispatch(
        removeTitleBarComponent(
          'marketLookbackDays',
          REMOVE_INPUT_FROM_TITLEBAR,
        ),
      );
    };
  }, [dispatch]);

  const type = useTitleBarSelect('selectMarketLookbackType') || 'vol';
  const lookbackDays = String(
    useTitleBarInput('marketLookbackDays') ?? '1',
  );

  const marketQuery = useMarketLookbackPageQuery(
    positionDate ?? '',
    lookbackDays,
  );

  return (
    <QueryBoundary<MarketLookbackPayload>
      isLoading={marketQuery.isLoading}
      isFetching={marketQuery.isFetching}
      isError={marketQuery.isError}
      error={marketQuery.error}
      data={marketQuery.data?.data}
      loadingMessages={['Loading Market...']}
      errorMessage="Unable to load Market data."
      noDataMessage="No Market data available."
    >
      {(data) => <MarketLookbackTable data={data} type={type} />}
    </QueryBoundary>
  );
};

export default MarketLookbackPage;
